// extracted by mini-css-extract-plugin
export default {"modal":"a44tPvU6z4fCmfScuVkj","brandLogo":"R2xe1VYqUrnbBNE2NI4r","body":"_jM_bU71QRMKaRJhlmzQ"};